"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointStatusCodeMessages = exports.EndpointStatusCodes = exports.EndpointContentTypes = exports.MicroScopes = exports.getEnvironmentUrl = exports.Environment = exports.AuthTokenType = exports.PagingEnum = exports.RootServices = void 0;
var RootServices;
(function (RootServices) {
    RootServices["DEFAULT"] = "DEFAULT";
    RootServices["APISERVER"] = "apiserver";
    RootServices["BUYERAPI"] = "buyerapi";
    RootServices["KUNAPI"] = "kunapi";
    RootServices["SELLERAPI"] = "sellerapi";
    RootServices["WECOM_MSG"] = "wecom-msg";
    RootServices["CCAPI"] = "ccapi";
    RootServices["OPENAPI"] = "openapi";
    RootServices["USERAPI"] = "user";
    RootServices["LIGHTHOUSEAPI"] = "lighthouseapi";
    RootServices["GDTCAPI"] = "gdtcapi";
    RootServices["PAYGW"] = "paygw";
})(RootServices = exports.RootServices || (exports.RootServices = {}));
var PagingEnum;
(function (PagingEnum) {
    PagingEnum["PAGE"] = "pageNo";
    PagingEnum["PAGE_SIZE"] = "pageSize";
    PagingEnum["TOTAL"] = "total";
})(PagingEnum = exports.PagingEnum || (exports.PagingEnum = {}));
var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType["ACCESS_TOKEN"] = "ACCESS_TOKEN";
    AuthTokenType["REFRESH_TOKEN"] = "REFRESH_TOKEN";
})(AuthTokenType = exports.AuthTokenType || (exports.AuthTokenType = {}));
var Environment;
(function (Environment) {
    Environment["Production"] = "production";
    Environment["Development"] = "development";
    Environment["Test"] = "test";
})(Environment = exports.Environment || (exports.Environment = {}));
const environmentUrls = {
    [Environment.Production]: 'https://buyerapi.chinagoods.com',
    [Environment.Test]: 'https://testbuyerapi.chinagoods.com',
    [Environment.Development]: 'https://devbuyerapi.chinagoods.com',
};
function getEnvironmentUrl(environment) {
    return environmentUrls[environment];
}
exports.getEnvironmentUrl = getEnvironmentUrl;
exports.MicroScopes = {
    APISERVER_SMS: `${RootServices.APISERVER}#` + `sms`,
    // 特殊界限
    APISERVER_PAGING: `${RootServices.APISERVER}#` + `PUBLIC_PAGING`,
};
var EndpointContentTypes;
(function (EndpointContentTypes) {
    EndpointContentTypes["JSON"] = "application/json;charset=UTF-8";
    EndpointContentTypes["FORM_URLENCODED"] = "application/x-www-form-urlencoded;charset=UTF-8";
    EndpointContentTypes["FORM_DATA"] = "multipart/form-data;charset=UTF-8";
})(EndpointContentTypes = exports.EndpointContentTypes || (exports.EndpointContentTypes = {}));
var EndpointStatusCodes;
(function (EndpointStatusCodes) {
    EndpointStatusCodes[EndpointStatusCodes["Ok"] = 20000] = "Ok";
    EndpointStatusCodes[EndpointStatusCodes["Created"] = 20001] = "Created";
    EndpointStatusCodes[EndpointStatusCodes["NoContent"] = 20004] = "NoContent";
    EndpointStatusCodes[EndpointStatusCodes["BadRequest"] = 40000] = "BadRequest";
    EndpointStatusCodes[EndpointStatusCodes["Unauthorized"] = 40001] = "Unauthorized";
    EndpointStatusCodes[EndpointStatusCodes["Forbidden"] = 40003] = "Forbidden";
    EndpointStatusCodes[EndpointStatusCodes["NotFound"] = 40400] = "NotFound";
    EndpointStatusCodes[EndpointStatusCodes["MethodNotAllowed"] = 40401] = "MethodNotAllowed";
    EndpointStatusCodes[EndpointStatusCodes["RequestTimeout"] = 40403] = "RequestTimeout";
    EndpointStatusCodes[EndpointStatusCodes["Conflict"] = 40900] = "Conflict";
    EndpointStatusCodes[EndpointStatusCodes["PayloadTooLarge"] = 40013] = "PayloadTooLarge";
    EndpointStatusCodes[EndpointStatusCodes["TooManyRequests"] = 42900] = "TooManyRequests";
    EndpointStatusCodes[EndpointStatusCodes["UnprocessableEntity"] = 42200] = "UnprocessableEntity";
    EndpointStatusCodes[EndpointStatusCodes["InternalServerError"] = 50000] = "InternalServerError";
    EndpointStatusCodes[EndpointStatusCodes["BadGateway"] = 50200] = "BadGateway";
    EndpointStatusCodes[EndpointStatusCodes["ServiceUnavailable"] = 50300] = "ServiceUnavailable";
    EndpointStatusCodes[EndpointStatusCodes["GatewayTimeout"] = 50400] = "GatewayTimeout";
})(EndpointStatusCodes = exports.EndpointStatusCodes || (exports.EndpointStatusCodes = {}));
exports.EndpointStatusCodeMessages = new Map([
    [EndpointStatusCodes.Ok, '请求成功'],
    [EndpointStatusCodes.Created, '请求已成功创建'],
    [EndpointStatusCodes.NoContent, '请求已成功处理，但没有返回任何内容'],
    [
        EndpointStatusCodes.BadRequest,
        '请求无效，缺少必要的请求参数或请求格式错误',
    ],
    [EndpointStatusCodes.Unauthorized, '请求未授权，请先登录'],
    [EndpointStatusCodes.Forbidden, '请求被拒绝访问'],
    [EndpointStatusCodes.NotFound, '请求的资源不存在'],
    [EndpointStatusCodes.MethodNotAllowed, '请求方法不被允许'],
    [EndpointStatusCodes.RequestTimeout, '请求超时'],
    [EndpointStatusCodes.Conflict, '请求冲突'],
    [EndpointStatusCodes.PayloadTooLarge, '请求数据过大'],
    [EndpointStatusCodes.TooManyRequests, '请求过于频繁'],
    [EndpointStatusCodes.UnprocessableEntity, '请求参数不符合要求，验证失败'],
    [EndpointStatusCodes.InternalServerError, '服务器内部错误'],
    [EndpointStatusCodes.BadGateway, '网关错误'],
    [EndpointStatusCodes.ServiceUnavailable, '服务不可用'],
    [EndpointStatusCodes.GatewayTimeout, '网关超时'],
]);
//# sourceMappingURL=types.js.map